<template><div><h1 id="verdankung" tabindex="-1"><a class="header-anchor" href="#verdankung"><span>Verdankung</span></a></h1>
<p>Verdankungen — Parameter und Protokolle von Verdankungsjobs</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Parameter, das Protokoll und die Funktionen des Jobs <RouteLink to="/referenz/refs/ft.refproc.verdankungen.html" title="Verdankungen erfassen/aufbereiten">Verdankungen erfassen/aufbereiten</RouteLink> werden hier zur Verfügung gestellt.</p>
<p>Pfad: <code v-pre>Personen → Verarbeitungsläufe → Verdankungen</code></p>
<h2 id="datenfelder-anzeige" tabindex="-1"><a class="header-anchor" href="#datenfelder-anzeige"><span>Datenfelder (Anzeige)</span></a></h2>
<dl>
<dt>Job-ID</dt>
<dd>Job-ID, fortlaufende Nummer zur Identifikation des Jobs, wird vom System vergeben.</dd>
<dt>Typ (PDF/E-Mail)</dt>
<dd>Typ, zeigt an ob der Job nur PDF's, nur E-Mails oder alles (PDF und E-Mail) berücksichtigt.</dd>
<dt>nur Verdankungsposition</dt>
<dd>Zeigt an, ob der Job nur eine bestimmte Verdankungsposition (auch Knoten möglich) oder alle Positionen berücksichtigt (alle = leer).</dd>
<dt>Status</dt>
<dd>Status des angezeigten Jobs. Folgende Stati sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Aufbereitung läuft</td>
<td>Die Aufbereitung der Verdankungen läuft</td>
</tr>
<tr>
<td>aufbereitet, Dokumente/E-Mails noch nicht erstellt</td>
<td>Die Verdankungen sind aufbereitet, die Dokumente sind aber noch nicht erstellt.</td>
</tr>
<tr>
<td>abgeschlossen, Dokumente/E-Mails erstellt, gedruckt/versendet</td>
<td>Die Verdankungen sind aufbereitet, die Dokumente sind erstellt und gedruckt bzw. E-Mails versendet. Die Reihenfolge der Erstellung der Dokumente erfolgt nach dem Dokumentensatz (alphabetisch). Verdankungspositionen mit dem selben Dokumentensatz werden in einem Dokument zusammengefasst. Die Reihenfolge innerhalb eines Dokuments ist zuerst nach Sprachcode (alphabetisch) und erst danach nach Dokumentencode (alphabetisch) sortiert.</td>
</tr>
<tr>
<td>zurückgesetzt</td>
<td>Die Verdankungen wurden zurückgesetzt, es ist ein neuer Job notwendig um die Verdankungen wieder aufzubereiten.</td>
</tr>
<tr>
<td>teilweise zurückgesetzt</td>
<td>Ein oder mehrere Positionen im Verdankungsjob wurden zurückgesetzt, es ist ein neuer Job notwendig um die Verdankungen wieder aufzubereiten.</td>
</tr>
</tbody>
</table>
</dd>
<dt>verdankt</dt>
<dd>Anzahl Verdankungen die verarbeitet und verdankt wurden (Total pro Job).</dd>
<dt>nicht verdankt</dt>
<dd>Anzahl Verdankungen die verarbeitet aber nicht verdankt wurden (Total pro Job).</dd>
<dt>Verdankung</dt>
<dd>Anzeige der Verdankungsposition</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung zur Verdankungsposition</dd>
<dt>verdankt (Verdankungen Positionen)</dt>
<dd>Anzahl Verdankungen die verarbeitet und verdankt wurden aufgeteilt nach Verdankungspositionen.</dd>
<dt>nicht verdankt (Verdankungen Positionen)</dt>
<dd>Anzahl Verdankungen die verarbeitet aber nicht verdankt wurden aufgeteilt nach Verdankungspositionen.</dd>
</dl>
<h2 id="datenfelder-erfassungsmodus" tabindex="-1"><a class="header-anchor" href="#datenfelder-erfassungsmodus"><span>Datenfelder (Erfassungsmodus)</span></a></h2>
<dl>
<dt>Job erfassen und aufbereiten</dt>
<dd>Der Verdankungsjob wird erfasst und die Verdankungen werden auch gleich aufbereitet. Nach der Aufbereitung werden die Ereignisverknüpfungen erstellt und die Anzahl Verdankungen gesamt und pro Verdankungsposition angezeigt.</dd>
<dt>Job erfassen aufbereiten und Dokumente erstellen</dt>
<dd>Dasselbe wie unter &quot;Job erfassen und aufbereiten&quot;, zusätzlich werden die Dokumente (PDF) erstellt.</dd>
<dt>Job erfassen aufbereiten und drucken/versenden</dt>
<dd>Dasselbe wie unter &quot;Job erfassen aufbereiten und Dokumente erstellen&quot;, zusätzlich werden die Dokumente (PDF) gedruckt und E-Mails versendet.</dd>
<dt>aufbereiten</dt>
<dd>Typ der Aufbereitung, nur PDF's, nur E-Mails oder alles (PDF und E-Mail).</dd>
<dt>nur Verdankungsposition</dt>
<dd>Auswahl einer bestimmten Verdankungsposition (auch Knoten möglich) oder alle Positionen (leer).</dd>
<dt>Briefdatum</dt>
<dd>Das Datum welches auf den Verdankungsbrief gedruckt wird.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="aufbereiten" tabindex="-1"><a class="header-anchor" href="#aufbereiten"><span>Aufbereiten...</span></a></h3>
<p>Ein abgebrochener Job (z.B. durch manuelle Intervention oder Server Restart, etc.) kann damit fortgesetzt werden.</p>
<h3 id="dokumente-e-mails-erstellen-drucken-versenden" tabindex="-1"><a class="header-anchor" href="#dokumente-e-mails-erstellen-drucken-versenden"><span>Dokumente E-Mails erstellen, drucken versenden...</span></a></h3>
<p>Erstellt nochmals die mit diesem Job aufbereiteten XML-Print-Output-Dateien und die Word-Steuerdatei. Dabei werden Änderungen in den Daten übernommen (z.B. Adressmutationen oder Änderungen in XML-Output-Texten).</p>
<h3 id="verdankungen-zurucksetzen" tabindex="-1"><a class="header-anchor" href="#verdankungen-zurucksetzen"><span>Verdankungen zurücksetzen...</span></a></h3>
<p>Setzt einen Verdankungsjob zurück. Der Job bleibt danach auf Status &quot;zurückgesetzt&quot; und kann danach weder editiert noch aufbereitet werden.</p>
<h3 id="protokoll-drucken" tabindex="-1"><a class="header-anchor" href="#protokoll-drucken"><span>Protokoll drucken...</span></a></h3>
<p>Druckt Listen der Verdankungen mit verschiedenen Gruppierungen.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/verdankungen.html" title="10. Verdankungen">Beschreibung Verdankungen</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.verdankungen.html" title="Verdankungen erfassen/aufbereiten">Verdankungsjob erfassen</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.vdanksteuer.html" title="Verdankungssteuertabelle">Verdankungssteuertabelle</RouteLink></p>
</div></template>


